export default __webpack_public_path__ + "static/media/achieve_bg.86ac8618.png";